import { SHARED_DEALS } from '../sharedConfig';

// Dedicated conquesting deal set for Kratom. The prospecting strategy reuses the
// standard cannabis-friendly SHARED_DEALS.
const KRATOM_CONQUESTING_DEALS = [
  { dealId: '387395937303', name: 'EBC All Cnbs Approved Deal ID Adelaide Deals' },
  { dealId: '170470292900', name: 'H_Cnbs Approved Semantic - Cnbs Content' },
  { dealId: '876571016345', name: 'EBC_USA_Sports Display_Cnbs Approved_suggested bid price is $3' },
  { dealId: '397100923868', name: 'EBC_US_Local News_Cnbs Approved_suggested bid price is $3' },
  { dealId: '619679920418', name: 'EBC_USA_Casino and Gambling Apps_Cnbs Approved_suggested bid price is $2' },
];

// budgetAllocation values are relative weights, NOT percentages.
// The formula (weight / sumOfSelectedWeights) × sourceBudget distributes 100%
// of the source line item's budget across whichever items are enabled.
export default {
  key: 'kratom',
  label: 'Kratom',
  strategySets: {
    prospecting: {
      label: 'Prospecting (4 items)',
      deals: SHARED_DEALS,
      lineItems: [
        { name: 'CPM_BT_SmokeShopVisitors_KnownVisitors_WithSegments_DIS_Prospecting', segment: 'SMOKE_SHOP_VISITORS_3M', budgetAllocation: 10 },
        { name: 'CPM_BT_DispensaryVisitors_KnownVisitors_WithSegments_DIS_Prospecting', segment: 'DISPENSARY_VISITORS_ALT', budgetAllocation: 30 },
        { name: 'CPM_BT_Fitness_KnownVisitors_WithSegments_DIS_Prospecting', segment: 'FITNESS_VISITORS', budgetAllocation: 10 },
        { name: 'CPM_BT_HealthWellness_VitaminsSupplements_WithSegments_DIS_Prospecting', segment: 'VITAMINS_SUPPLEMENTS', budgetAllocation: 10 },
      ],
    },
    conquesting: {
      label: 'Conquesting (1 item)',
      deals: KRATOM_CONQUESTING_DEALS,
      lineItems: [
        { name: 'CPM_CQ_x_x_21plusonly_DIS_Conquesting', segment: 'BROAD_21PLUS', budgetAllocation: 40 },
      ],
    },
  },
  deals: SHARED_DEALS,
};
